"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.coin = exports.bounce = void 0;

var _util = require("../../../util");

const bounce = () => ({
  '0%, 12%': {
    timingFunction: 'cubic-bezier(0.17, 0.17, 0.00, 1.00)',
    transform: 'none'
  },
  '44%': {
    timingFunction: 'cubic-bezier(0.17, 0.17, 0.00, 1.00)',
    transform: 'translateY(-300%)'
  },
  '64%': {
    timingFunction: 'cubic-bezier(1.00, 0.20, 0.83, 0.83)',
    transform: 'none'
  },
  '75%': {
    timingFunction: 'cubic-bezier(0.17, 0.17, 0.35, 1.00)',
    transform: 'translateY(-75%)'
  },
  '87%': {
    timingFunction: 'cubic-bezier(0.65, 0.00, 0.83, 0.83)',
    transform: 'none'
  },
  '92%': {
    timingFunction: 'cubic-bezier(0.17, 0.17, 0.67, 1.00)',
    transform: 'translateY(-30%)'
  },
  '95%, 100%': {
    timingFunction: 'cubic-bezier(0.33, 0.00, 0.67, 1.00)',
    transform: 'none'
  }
});

exports.bounce = bounce;

const coin = ({
  cssProps,
  theme
}) => {
  const {
    animation,
    index,
    coinColor = 'background.inverse'
  } = cssProps;
  return {
    animation: "".concat(animation, " 900ms infinite"),
    animationDelay: "".concat(500 + 30 * index, "ms"),
    background: (0, _util.color)(theme, coinColor),
    borderRadius: '50%',
    height: 6,
    width: 6
  };
};

exports.coin = coin;
//# sourceMappingURL=Loading.style.js.map